import React, { useState, useCallback } from "react";

import { Link, useLoaderData, useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import FilesForm from "Components/Files/FilesForm";
import Paper from "Components/UI/Paper";
import { getUploadErrorMessage, uploadFile } from "API/swesum";

import { usePopupNotificationContext } from "Context/NotificationPopup";
import { LoadingButton } from "@mui/lab";

const initFormData = {
  FileId: null,
  SystemStatus: "",
  ParseStatus: "",
  ParseMessage: "",
  Name: "",
  FileType: "",
  Category: "",
};

export function UploadFiles() {
  const { openError, openSuccess } = usePopupNotificationContext();
  const navigate = useNavigate();
  const [formData, setFormData] = useState(initFormData);

  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleInputChange = useCallback(
    (field, newVal) => {
      setFormData({ ...formData, [field]: newVal });
    },
    [formData]
  );

  const handleFileSelect = ({ target }) => {
    if (target.files[0] !== undefined) {
      const file = target.files[0];
      const newFiles = [];
      for (const file of target.files) {
        newFiles.push({
          Content: file,
          FileType: file.type,
          FileName: file.name,
        });
      }

      const fileName = newFiles.map((file) => file.FileName);
      setFormData({
        ...formData,
        Name: fileName.join(", "),
        FileType: `${file.type}`,
      });
      setFiles(newFiles);
    }
  };

  const save = async () => {
    setLoading(true);
    if (files.length > 0) {
      const errors = [];
      await Promise.all(
        files.map(async (file) => {
          const multipartFormDataObj = new FormData();
          multipartFormDataObj.append("FileType", file.FileType);
          multipartFormDataObj.append(
            "Content",
            new Blob([file.Content], { type: file.Content.type }),
            file.FileName
          );
          multipartFormDataObj.append("Category", formData.Category);

          try {
            await uploadFile(multipartFormDataObj);
          } catch (error) {
            errors.push(
              getUploadErrorMessage(
                error,
                `Ett fel uppstod när ${file.FileName} skulle laddas upp.`
              )
            );
          }
        })
      );
      if (errors.length > 0) {
        openError(errors.join(" "));
      } else {
        openSuccess(`OK! ${files.length} filer har laddats upp`);
        setFormData(initFormData);
        setFiles([]);
      }
    } else {
      openError("Välj en fil att ladda upp.", 3000);
    }
    setLoading(false);
  };

  return (
    <Box padding={2}>
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Typography sx={{ marginBottom: "1.0rem" }} variant="h5" align="left">
          Skapa fil
        </Typography>

        <Button component="label" variant="contained">
          Välj filer
          <input type="file" multiple hidden onChange={handleFileSelect} />
        </Button>
      </Box>

      <Paper sx={{ marginTop: 2 }}>
        {formData && (
          <FilesForm
            formData={formData}
            handleInputChange={handleInputChange}
          />
        )}

        <Grid
          item
          xs={12}
          md={12}
          sx={{
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <Button component={Link} to="/files" sx={{ ml: 1 }}>
            Stäng
          </Button>
          <LoadingButton
            loading={loading}
            onClick={save}
            variant="contained"
            sx={{ ml: 3 }}
          >
            Spara
          </LoadingButton>
        </Grid>
      </Paper>
    </Box>
  );
}
